<template>  
  <button class="flex items-center gap-2" @click="useUpdateQuery({ locationModal: true })">
    <div class="w-5 h-5 flex items-center justify-center bg-sky text-ocean rounded-full">
      <AtomIcon name="chevron-down" class="text-sm" />
    </div>
    <div class="font-medium whitespace-nowrap" v-auto-animate>
      <div v-if="!fat.cityId" v-html="$t('shared.sweden')" />
      <div v-else-if="fat.hasUserLocation && route.name.startsWith('fat')" v-html="$t('fat.location.nearMe')" />
      <div v-else-if="fat.hasLocation && route.name.startsWith('fat')" v-html="$t('fat.location.onMap')" />
      <div v-else v-html="fat.city?.name" />
    </div>
  </button>
</template>

<script setup>
const route = useRoute()
const fat = useFatStore()
</script>
